/*$('.content-page__side-title').click(function(){
  console.log('click');
  $('.content-page__side-list').toggleClass('content-page__side-list_open');
});*/

$('.content-page__side-btn').click(function(){
  $('.content-page__cell_menu-side').toggleClass('content-page__cell_menu-side_open');
  $('#sb-site').toggleClass('sb-site_z2');
});
